import { useRef, useMemo } from 'react';
import { createIceSurface } from '../theme/surfaces';

interface UseIceSurfaceOptions {
  transparent?: boolean;
  icicles?: boolean;
  card?: boolean;
  rainbowSheen?: boolean;
}

/**
 * Returns a stable, per-instance ice surface style object.
 *
 * A random seed is generated once when the component mounts and never
 * changes, so each component instance always renders the same unique
 * ice crystal pattern across re-renders.
 */
export function useIceSurface(options?: UseIceSurfaceOptions) {
  const seedRef = useRef<number | null>(null);
  if (seedRef.current === null) {
    seedRef.current = Math.floor(Math.random() * 99999);
  }
  // Stringify options so the memo only recomputes if they actually change
  const key = JSON.stringify(options ?? {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => createIceSurface(seedRef.current!, options), [key]);
}
